import React from 'react'
import Header from './components/Header'
import Content from './components/Content'
import "./App.scss"
const App = () => {
    return (
        <>
            <Header/>
            <Content/>
        </>
    )
}

export default App
